var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPokerDiamondsFill = function SvgPokerDiamondsFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m5.363 10.945 5.992-7.323a.833.833 0 0 1 1.29 0l5.991 7.323a1.67 1.67 0 0 1 0 2.11l-5.991 7.323a.833.833 0 0 1-1.29 0l-5.992-7.323a1.67 1.67 0 0 1 0-2.11"
  })));
};
export default SvgPokerDiamondsFill;